import { rolesManagementApi, usersManagementApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectRoles } from 'store/global/selectors';

import { selectUserRoles } from '../selectors';

export const USER_ROLE_ACTION_TYPE = createNamedActions('userRole', {
  GET_USER_ROLES: 'GET_USER_ROLES',
  SET_USER_ROLE: 'SET_USER_ROLE',
  DELETE_USER_ROLE: 'DELETE_USER_ROLE',
});

const userRolesSchema = new schema.Entity('roles', {}, { idAttribute: 'id' });

export const getUserRolesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await rolesManagementApi.getRoles(params);

  return dispatch({
    type: USER_ROLE_ACTION_TYPE.GET_USER_ROLES,
    payload: normalize(data, [userRolesSchema]).entities.roles,
  });
});

export const createUserRoleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const state = getState();
  const roles = selectRoles(state);

  await usersManagementApi.createUserRoleAssignments(params);

  // TODO: jwt should be updated after changing role for master user. Otherwise actual data about master roles will be replaced with data from jwt after page reload.
  return dispatch({
    type: USER_ROLE_ACTION_TYPE.SET_USER_ROLE,
    payload: { ...roles[params.roleId] },
    meta: params,
  });
});

export const deleteUserRoleAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const state = getState();
  const roles = selectUserRoles(state);

  await usersManagementApi.deleteUserRoleAssignments(params);

  return dispatch({
    type: USER_ROLE_ACTION_TYPE.DELETE_USER_ROLE,
    payload: { ...roles[params.roleId] },
    meta: params,
  });
});
